module.exports = __webpack_public_path__ + "img/arrow-slider-prev.4386900d.svg";